export class TenantsModel {
    public Id: number;
    public Name: string;
    public SiteName: string;
    public Email: string;
    public Phone: string;
    public EmailTemplate: string;
    public Image: String;
    public PermiseType: number = 0;
    public VisitingAddress: string;
    public UserName: string;
    public Password: string;
    public InsuranceCompany: string;
    public SecurityCompany: string;
    public SiteManagerName: string;
    public SiteManagerMobilePhone: string;
    public SiteManagerPhone: string;
    public ContractName: string;
    public ContractVatNo: string;
    public InvoiceAddress: string;
    public InvoiceZipAndCity: string;
    public ContactComments: string;
    public CCTV: boolean = true;
    public IntrusionAlarm: boolean = true;
    public SiteManagerEmail: string;
    public Flag: boolean = false;
    public PropertyDesignation: string;
    public UseWrittenStatement: boolean = false;
    public TenantType: number = 0;
    public TenantTypeName: string = ""; // todo: not implemented
    public SubPremiseType: number = 0;
    public LastUpdatedByCustomer: Date;
    public OffSet: any;
    public IsSent: boolean;
    public IsActive: boolean;
    public LastSentUpdateEmail: Date;
    public Site: any = {
        Id: 0,
        Name: '',
        Address: '',
        City: ''
    };
    public City: string;
    public ZipCode: string;
    public Company: string;

    public PostAddress: string;
    public PostZipCode: string;
    public PostCity: string;
    public AccountId: number;
    public LastUpdatedBy: number;
    public LastUpdatedByName: string;
    public IsFromPublicPage: boolean;
    public ImageUrl: string;
}

export class TenantTypesModel {
    public Id: number = 0;
    public TypeName: string;
    public Description: string;
    public AccountId: number = 0;
}

export class PremiseTypesModel {
    public Id: number = 0;
    public TenantTypeId: number = 0;
    public TypeName: string;
    public Description: string;
    public AccountId: number = 0;
}

export class SubPremiseTypesModel {
    public Id: number = 0;
    public PremiseTypeId = 0;
    public TypeName: string;
    public Description: string;
    public AccountId: number = 0;
}

export class JobTitlesModel {
    public Id: number = 0;
    public TitleName: string;
    public Description: string;
    public AccountId: number = 0;
    public IncludedOnExcelExport: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/TenantModel.ts